export const talks = [
  {
    id: '73c02df3-9e6c-44ea-896c-ede9a6a2f14d',
    description:
      'The talk will the cover the use cases of putting together Google BigQuery with Geospatial data from different technologies on Google Cloud. The purpose of the discussion is to inform on how data can be enhanced and how geospatial information can be a huge benefit for new implementations within organisations with little additional development and hardly any new data.',
    facebookText:
      'Big Data meets Geospatial and how it can help business grow and life better in one go.',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'intermediate',
    speakers: ['93da93d0-6fdd-4984-9312-cd97482d48b6'],
    talkType: 'introduction',
    title: 'Big Data meets Geospatial',
    track: 'Talk',
    twitterText:
      'Big Data meets Geospatial and how it can help business grow and life better in one go.',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: '',
    talkGroup: '',
    order: 1,
    stream: ['Data Science', 'Innovation and Sustainability', 'User Interaction'],
    conferenceDay: 'day2',
    startTime: '13:10',
    endTime: '13:50',
    trackInDay: 3
  },
  {
    id: '02f1a1ce-9bd5-44aa-9c23-77c963b6ba41',
    description:
      'A comprehensive introduction to understanding the Metaverse, including its main experiential components and technology layers, what is real and what is not real, the ethical implications, the primary use cases, and why it is crucial for both customer interactions and enterprise transformation.',
    facebookText:
      "Don't miss Nick Rosa from Accenture and his speech “Understanding the Metaverse“, a comprehensive introduction to this new infrastructure, its main experiential components and technology layers, the primary use cases, and why it is crucial for both customer interactions and enterprise transformatio",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['ca2607b8-3e62-4625-9cdc-e5cbf2094ee4'],
    talkType: 'introduction',
    title: 'Understanding the Metaverse',
    track: 'Talk',
    twitterText:
      "Don't miss @nicolarosa speech at @OpenSlava conference #understandingthemetaverse",
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: '',
    youtube: 'https://youtu.be/QnRjIrRByWM',
    talkGroup: '',
    order: 1,
    stream: ['Lightning Talk'],
    conferenceDay: 'day2',
    startTime: '09:10',
    endTime: '09:40'
  },
  {
    id: '60bcd045-527c-40fc-86b5-1fff96f1542e',
    description:
      "Experience building a modern integrated application development environment on a student's budget. Understand how it works and make your life easier by doing things a bit more sophisticated.",
    facebookText:
      "Join the workshop of Moritz, Pavel & Matus from Erste Digital and experience building a modern integrated application development environment on a student's budget. Understand how it works and make your life easier by doing things a bit more sophisticated.",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'everyone',
    speakers: [
      '5306358d-11ef-4b69-b8a4-b7b45b4193ae',
      'a87d6921-cf83-4215-9207-26f667e30098',
      'c06feb54-fa4c-4789-9cf8-2bba2f82c1d1'
    ],
    talkType: 'advanced',
    title: "Poor man's enterprise-like CI/CD toolchain",
    track: 'Hands-on Lab/workshop',
    twitterText:
      'Join Moritz, Pavel & Matus and experience building a modern integrated application development environment at OpenSlava.',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'BC 35',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '08:30',
    endTime: '11:30',
    trackInDay: 0
  },
  {
    id: '937b1dd7-2415-43b1-8d27-747e1c88c4d1',
    description:
      "Large corporations producing medical devices can have big carbon footprint in the area of software distributions while ensuring safety of their installed products. Let's check potential innovation, cost saving and sustainability inside big companies producing medical devices through common infrastructural solutions in the area of SW deployment.",
    facebookText:
      'Carbon footprint and environment pollution is not just manufactory or transport problem. Join Matej Adamcik for his session at OpenSlava 2022 to check how software deployment can minimize these negative effects.',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['5893c0b1-c46c-44fd-8d63-806a37c271fb'],
    talkType: 'introduction',
    title: 'How technology can minimize carbon footprint in SW deployment area',
    track: 'Talk',
    twitterText:
      'Join Matej Adamcik for his session at OpenSlava 2022 to check how software deployment can minimize carbon footprint.',
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: '',
    youtube: 'https://youtu.be/dPC1fm-_68A',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '16:00',
    endTime: '16:40',
    trackInDay: 0
  },
  {
    id: 'a50142b6-863b-4cfc-9f3e-a4c901c7f56c',
    description:
      'Finance is quite conservative industry. Finances are a sensitive topic, and that is the reason, why access to finances is highly regulated.  PSD2 directive was approved in 2015, and was introduced into implementation in 2018 with the aim to support and speed innovation in a finance industry. But regulation is not the right way, how to speed up the innovation. There needs to be gain on all sides: Banks, Fintechs, and of course customer. Fintechs have today limited access to Bank services, therefore space for innovations is limited as well. Innovation forced by regulation bring little, or no value for the customer and we would like to change it. Golden egg will be revealed during our speech at Openslava. ',
    facebookText:
      'Finances are a sensitive topic, and that is the reason, why access to finances is highly regulated. But innovation forced by regulation bring little, or no value for the customer and we would like to change it. Golden egg will be revealed during our speech at Openslava',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['6c77f847-47c2-4e76-9364-773cdc757098'],
    talkType: 'introduction',
    title: 'Future world is connected world – To deliver value we have to join forces',
    track: 'Talk',
    twitterText: 'Join me in discussion about opportunities brought by Openbanking in #openslava',
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: '',
    youtube: 'https://youtu.be/597kF1GVMmY',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '14:00',
    endTime: '14:40',
    trackInDay: 0
  },
  {
    id: '70f69c68-8d02-4399-8a15-35b74dc4a4a7',
    description:
      'Even if it might not replace your fraud-detection system, it might help you to understand, what is going on. We will cover the process through following blocks: 1) Data prepration - generate and preprocessing 2) Data vizualization - geoanalytics, ... 3) Model creation - ML/DL iterative modelling for Fraud detection usecase',
    facebookText:
      'Insight into customer payment data analysis - detection and visualization of fraud patterns hidden in numerous transactions',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: ['3117bdb6-363f-4a88-abc8-dd44126b1f56', '8a8535e4-115e-426b-a558-6f84fdd5d258'],
    talkType: 'advanced',
    title: 'Fraud detection and geoanalytics use cases on customer payment transactions',
    track: 'Hands-on Lab/workshop',
    twitterText:
      'Insight into customer payment data analysis - detect and visualize fraud patterns hidden in numerous transactions',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'BC 35',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '12:00',
    endTime: '15:00',
    trackInDay: 2
  },
  {
    id: '762d4550-35cb-470a-ba8c-b71c3c09c537',
    description: 'N/A',
    facebookText:
      'Join Optimization of datasets workshop where you can find out how 90% of companies are working with data. And see how others 10% are doing it right!',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: ['e3f7bee1-fa44-4680-9d02-cd1450220ef1'],
    talkType: 'introduction',
    title: 'Cancelled',
    track: 'Hands-on Lab/workshop',
    twitterText:
      'Do you really know your data? Do you really know how to effective process them? Join Optimization of datasets workshop!',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'Room 3',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '08:30',
    endTime: '11:30',
    trackInDay: 2
  },
  {
    id: 'a0037058-d17c-433d-b6a8-9cc88d5c6528',
    description:
      'Digital Identity and its underlying infrastructure is a key element of securely accessing, claiming, verifying and owning things in the metaverse. This is an overview of the evolution of digital identities, its applicability and its technologies like zero knowledge proofs. We will double click into the key elements that are key to shaping the future of digital identity and where they are applied. No math skills required!',
    facebookText:
      '@OpenSlava @bjoobe Björn Obermeier #Metaverse #Blockchain #Digital Identity #Accenture',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'beginner',
    speakers: ['7c244790-59af-4f96-ab98-e46728816585'],
    talkType: 'introduction',
    title: 'Who Am I in the Metaverse - Digital Identity',
    track: 'Talk',
    twitterText:
      '@OpenSlava @bjoobe Björn Obermeier #Metaverse #Blockchain #Digital Identity #Accenture',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/a8JIo2eiS8E',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '14:00',
    endTime: '14:40',
    trackInDay: 1
  },
  {
    id: '481cf0cd-db66-496e-95f5-a7dbc95e6bed',
    description:
      'Technical presentation about Big Data cluster at Erste. What approach and technology used by building data lake.',
    facebookText:
      "Is hadoop dead technology? Not at Erste. Let's us show you how we built data lake on hadoop. What we learn and we're heading. ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'intermediate',
    speakers: ['14feb7b1-28e5-4abe-9629-adbdd996ecf5'],
    talkType: 'introduction',
    title: 'Building the Group Data Lake on Hadoop technology',
    track: 'Talk',
    twitterText:
      "Is hadoop dead technology? Not at Erste. Let's us show you how we built data lake on hadoop.",
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/pr0awL-1CPM',
    talkGroup: '',
    order: 1,
    stream: ['Data Science', 'Other'],
    conferenceDay: 'day2',
    startTime: '14:00',
    endTime: '14:40',
    trackInDay: 3
  },
  {
    id: '68097f83-ae6f-4b2a-bccb-aeb7a298ed5f',
    description:
      'Quantum Computing (OC) has the potential to be a key technology of the 21st century. Quantum Machine Learning (QML) is a rapidly emerging field that could lead to significant speed-ups in machine learning use cases. This talk will discuss chances and barriers. ',
    facebookText:
      'Quantum Computing (OC) has the potential to be a key technology of the 21st century. Quantum Machine Learning (QML) is a rapidly emerging field that could lead to significant speed-ups in machine learning use cases. This talk will discuss chances and barriers.',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'intermediate',
    speakers: ['b3423919-9b59-4c39-a47b-28f5235a0a1b'],
    talkType: 'advanced',
    title: 'Quantum Machine Learning: Opportunities & Limitations',
    track: 'Talk',
    twitterText:
      'What are the chances and barriers of Quantum Machine Learning for ML use case speed-ups?',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/bHgm22v8y6s',
    talkGroup: '',
    order: 1,
    stream: ['Data Science', 'Innovation and Sustainability', 'Other'],
    conferenceDay: 'day2',
    startTime: '13:10',
    endTime: '13:50',
    trackInDay: 0
  },
  {
    id: '860ee988-f2c2-4300-a51b-e29442cfdc23',
    description:
      'Today the second quantum revolution is unfolding worldwide. It aims to bring disruptive quantum technologies to the scientific arena and to society in general by bringing forward new commercial opportunities addressing global challenges, providing strategic capabilities for security and seeding yet unimagined applications for the future. In response, the EU has launched a network of European Quantum Technologies programs that will foster an ecosystem capable of delivering the knowledge, technologies and open research infrastructures and testbeds necessary for developing a world-leading knowledge-based industry in Europe. It is essential that Slovakia is part of this process.   In my talk, I will introduce the emergent quantum (information) technology field. In order to appreciate better the transformative potential of quantum technologies, I will explain the basic principles of non-relativistic quantum physics. In particular, I will describe in detail two phenomena: quantum superpositions and quantum entanglement. On top of this, quantum measurements will be discussed in some detail. Finally, I will present two examples of quantum technologies: the quantum computer and quantum-key-distribution schemes.',
    facebookText:
      'Vladimir Buzek will present @OpenSlava an introductory talk explaining the basic principles of quantum technologies.',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'beginner',
    speakers: ['1c5f8915-abfc-43a4-85d3-90bb0c78b7fd', 'f35bbaff-d46a-4315-8f5c-71e751424a8f'],
    talkType: 'introduction',
    title: 'Second Quantum Revolution',
    track: 'Talk',
    twitterText:
      'Vladimir Buzek will present @OpenSlava an introductory talk explaining the basic principles of quantum technologies.',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: '',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability', 'Other'],
    conferenceDay: 'day2',
    startTime: '11:30',
    endTime: '12:10',
    trackInDay: 0
  },
  {
    id: 'b0b4e781-a0ba-47d4-b69d-7e3aee568e42',
    description:
      "Does your manager make you use containers everywhere? Do developers next-door throw them containers at you? No time to patch or even set your DB server?  Well, don't we have a session just for you!  Cool proof of concepts of using serverless solutions in Google Cloud, mixed and seasoned with well chosen managed DBs on a side.",
    facebookText: 'will be provided later',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: ['5fd95a92-7b7b-4ff5-a3f9-491f064c431f', 'edbc5832-77ed-4e58-93d8-2272208a74f5'],
    talkType: 'advanced',
    title: 'Serveless, serverless everywhere',
    track: 'Hands-on Lab/workshop',
    twitterText: 'will be provided later',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'B klub',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '12:00',
    endTime: '15:00',
    trackInDay: 3
  },
  {
    id: '80f940d6-72e6-4a55-af75-43e8b7265951',
    description:
      'Digitalization is leading us towards a future where people, processes, data and things are not only interacting with each other, but might start forming societies on their own. In these dynamic systems enhanced by artificial intelligence, trust management on the level of human-to-machine as well as machine-to-machine interaction becomes an essential ingredient to supervise safe and secure progress of our digitalized future. In this talk, we will look into the essential elements of trust management in complex digital ecosystems, and discuss how trust-building can be leveraged to support people in safe interaction with other autonomous digital agents (e.g., self-driving cars, drones, and other robotic systems).',
    facebookText:
      'Digitalization is leading us towards a future where people and autonomouos systems (like self-driving cars) are not only interacting with each other, but might start forming societies on their own. How can we supervise safe progress of autonomous ecosystems and our digitalized future?',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['ac8ffdef-fcab-41cd-b48a-50d66bf71acc'],
    talkType: 'introduction',
    title: 'Do you trust autonomous ecosystems?',
    track: 'Talk',
    twitterText:
      'Do you trust autonomous systems? How can we supervise their safe progress? With @barabuhnova at @OpenSlava.',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/mRjszrI0jDo',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '16:00',
    endTime: '16:40',
    trackInDay: 2
  },
  {
    id: 'e5d4990b-1286-46ba-9215-b877c1700eda',
    description:
      'How to apply MetaDevops to your life. Managing DevOps infrastructure with minimal effort directly in Kubernetes. Monitor your application environments as Kubernetes resources (Crossplane + Gitlab). Demonstration of architecture implementation on real use case with live demo.',
    facebookText:
      'Managing DevOps in Kubernetes as Kubernetes resources (Crossplane + Gitlab). Including real live demo.',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: [
      'c672588e-7f74-4583-a2d0-e0da41ac410e',
      'ee3c5804-661c-4181-ab1b-3e405e96f2b7',
      'f3282e69-a540-4598-b9f7-f57d4f411bd0'
    ],
    talkType: 'advanced',
    title: 'Metadevops',
    track: 'Talk',
    twitterText:
      'Managing DevOps in Kubernetes as Kubernetes resources (Crossplane + Gitlab). Including real live demo.',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/Q_wX4IyB-cg',
    talkGroup: '',
    order: 1,
    stream: ['Dev-Sec-Ops', 'Live Coding Session'],
    conferenceDay: 'day2',
    startTime: '16:00',
    endTime: '16:40',
    trackInDay: 4
  },
  {
    id: '90ea097a-1f30-4c77-8f09-f2efe7b5fc63',
    description:
      'Calling developers that want to understand the OpenShift approach to GitOps. Having Git repositories as a single source of truth allows development teams to store the entire state of the cluster configuration in Git so that the trail of changes are visible and auditable. Argo CD is a declarative, GitOps continuous delivery tool for Kubernetes, fully supported by OpenShift and OpenShift GitOps. OpenShift GitOps follows the GitOps pattern of using Git repositories as the source of truth for defining the desired application state and automates the deployment of the desired application states in the specified target environments. Application deployments can track updates to branches, tags, or pinned to a specific version of manifests at a Git commit.  What you will learn:  The fundamentals of GitOps and Argo CD How to install and managed Argo CD in Kubernetes via OpenShift GitOps Deploying and sync the desired application deployment state Use Kustomize with Argo CD Use Sync Waves and Hooks with Argo CD',
    facebookText: 'Calling developers that want to understand the #OpenShift approach to #GitOps.',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: ['39d01aea-fe73-47cc-898a-f13f3067cebf', '9eb492c1-2d92-4755-81d0-22b33e231b0d'],
    talkType: 'introduction',
    title: 'Openshift GitOps',
    track: 'Hands-on Lab/workshop',
    twitterText: 'Calling developers that want to understand the #OpenShift approach to #GitOps.',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'E 702',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '12:00',
    endTime: '15:00',
    trackInDay: 0
  },
  {
    id: '3c0cab80-3735-4c51-b781-a1b45645e31e',
    description:
      'In this hands-on lab we will work with an object detection model using OpenShift Data Science and deploy it as part of a containerized application.',
    facebookText:
      'Join us for a hands-on workshop on deploying an AI-based object detection application on OpenShift.',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: ['3fa8b9a0-086c-4991-ba1b-cab2d04191e0'],
    talkType: 'advanced',
    title: 'Object Detection on OpenShift',
    track: 'Hands-on Lab/workshop',
    twitterText:
      'Join us for a hands-on workshop on deploying an AI-based object detection application on OpenShift.',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'E 702',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '15:30',
    endTime: '18:30',
    trackInDay: 2
  },
  {
    id: '81deeef0-b68a-4ed5-bfc3-d95a31be0ae1',
    description:
      'Join our workshop and learn how to effectively generate innovative ideas in a team and bring them to a final presentable concept.  With our coaches, you will learn and practice various Design Thinking methods. You will experience how diverse initial inputs can be transformed into a meaningful and powerful ideas that you can present to your board, client or other partners in a completely different way.',
    facebookText:
      'Join our workshop and learn how to effectively generate innovative ideas in a team and bring them to a final presentable concept.  With our coaches, you will learn and practice various Design Thinking methods. You will experience how diverse initial inputs can be transformed into a meaningful ideas.',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'beginner',
    speakers: [
      'a57e8e14-cb53-4e0b-9ca1-18ed1e5b2643',
      'aac7c34e-9784-4b9e-9e56-8a99c3c122e3',
      'e73e8286-7b43-4c39-ab5f-8a1d954a3176',
      'f8c1d95e-8459-4c0a-85dd-08b115a32538'
    ],
    talkType: 'advanced',
    title:
      'Let’s create and develop innovative ideas using the Design Thinking methodology - (All day event)',
    track: 'Hands-on Lab/workshop',
    twitterText:
      'Learn how to effectively generate innovative ideas in a team using Design Thinking methods.',
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: 'D2 - Accenture Campus Lab',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '08:30',
    endTime: '18:30',
    trackInDay: 5
  },
  {
    id: '3e3a5ac1-057e-447b-88e5-1ff59cd02041',
    description:
      'Although quantum computing is still in its infancy today, the disruptive possibilities of this technology can already be seen in various fields. Whether for simulating molecules for materials research or drug discovery, improving machine learning models for detecting credit card fraud, or even optimizing ship routes to minimize CO2 emissions, quantum computing will make many such previously intractable problems solvable through an immense speedup or better accuracy. At the same time, no structured software engineering for quantum solutions has been established yet. Therefore, this talk will present technical concepts and methodological approaches on how quantum solutions can be thought of and developed as monetizable products at an early stage. ',
    facebookText:
      'Michael Falkenthal will present technical and methodological concepts on how quantum solutions can be developed and monetized in his talk “APIfication of Quantum Algorithms and Applications” @OpenSlava',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['bcd0aaf4-ef85-4317-91e2-64f9b724c2ba'],
    talkType: 'introduction',
    title: 'APIfication of Quantum Algorithms and Applications',
    track: 'Talk',
    twitterText:
      'Michael Falkenthal will talk about the “APIfication of Quantum Algorithms and Applications” @OpenSlava',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/qw8ykG2ibK0',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability', 'Other'],
    conferenceDay: 'day2',
    startTime: '15:10',
    endTime: '15:50',
    trackInDay: 0
  },
  {
    id: 'e1935fa1-425e-4879-85ee-0e9398600692',
    description:
      'Development of a platform for portfolio optimization using a quantum algorithm versus a classical approach.',
    facebookText: '-',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'intermediate',
    speakers: ['50ff3762-b973-4242-8a4d-5788af06b827', 'ede9468a-0919-4b0c-a4d1-eb597a3186fe'],
    talkType: 'advanced',
    title: 'Sustainable Quantum Portfolio Optimization',
    track: 'Talk',
    twitterText: '-',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/hljJPRHFoko',
    talkGroup: '',
    order: 1,
    stream: ['Data Science', 'Innovation and Sustainability', 'Other'],
    conferenceDay: 'day2',
    startTime: '16:00',
    endTime: '16:40',
    trackInDay: 3
  },
  {
    id: '7c62d310-4c2c-40dc-b6d3-894f2350558e',
    description:
      'Robots are coming into the wild, i.e. robots are increasingly used outside the manufacturing shopfloors and warehouses. It’s an interesting and growing field for software engineers!  Today, robots can relieve people from dull and dangerous tasks also in less predictable environments and situations such as inspecting industrial sites and assets. This session is about diving into the business and technology aspects of autonomous robotics systems used for inspection by diving into two client-inspired showcases with different technology stacks 1) end-to-end drone inspection of a harbor and 2) legged-robot inspection of an energy plant.  The implementation of robotic systems requires cross-disciplinary work from different field applying systems thinking across embedded, computer vision, signal processing, optimization, connectivity, distributed systems, cloud, user experience and human machine interaction. We will explain the term Full-Stack Roboticists and explain the opportunities for developers.',
    facebookText:
      'Robots are coming into the wild! A lot of opportunities not only for businesses but also for developers...',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'beginner',
    speakers: ['9ea119a0-af98-4f97-a7c2-4f55eec98531'],
    talkType: 'introduction',
    title: 'Robots are coming into the wild! Full-Stack Robotics Engineers, be ready!',
    track: 'Talk',
    twitterText:
      'Robots are coming into the wild! A lot of opportunities not only for businesses but also for developers...',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/MiQW1jhM_yg',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '14:00',
    endTime: '14:40',
    trackInDay: 4
  },
  {
    id: 'beea103c-813c-4bac-9b89-e18d9594482d',
    description:
      'LIVE DEMO OF AUTONOMOUS BOTS  Intelligent AGVs are the future of shopfloor management. Small autonomous vehicles provide a unique solution to transport goods on a shopfloor and enter inaccessible and dangerous areas. Moreover, lack of internet connectivity has always been a restrictive factor for such technologies. Therefore, in this talk we present an Intelligent Edge-solution where Cloud meets Edge to overcome such issues. AGVs with object detection capabilities thus enabling them to not just navigate autonomously through restrictive paths of shopfloor but also detect objects in its path. ',
    facebookText:
      'We bring a unique solution where Cloud meets Edge to make AGVs even more intelligent thus changing shopfloor management forever! #itotengineering #AI  ',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['0e26d8c9-7526-40d7-92cf-55876dc80bd0', '6c784115-1116-4452-b715-f937e4690639'],
    talkType: 'expert',
    title: 'Autonomous Mobile Robots enabled by Intelligent Edge',
    track: 'Talk',
    twitterText:
      'A unique solution where Cloud meets Edge to make AGVs intelligent thus changing shopfloor management #itotengineering ',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/O_LZWrPZqTw',
    talkGroup: '',
    order: 1,
    stream: ['Application Logic', 'Innovation and Sustainability', 'User Interaction'],
    conferenceDay: 'day2',
    startTime: '15:10',
    endTime: '15:50',
    trackInDay: 4
  },
  {
    id: 'e5b6508a-3ee0-489f-a95d-54c79e604e77',
    description:
      'The Metaverse creates a new culture for consumers to become co-creators of a brand’s estate and products. It moves the centre of gravity from the boardroom to loyal communities who co-own and care for the brand’s legacy.   Decentralization of power through Web3, as well as the emergence of new consumer architypes roaming multiple worlds, are the new paradigms businesses need to adopt in the next evolution of the internet.  In this talk, I want to introduce the concept of Omnireality and how I believe it sets the blueprint to address this paradigm shift when we define future strategies in the Metaverse. Omnireality is the strategy for a business to be present and smoothly flow across a continuum of different realities of place, people, and products on the Metaverse. It is a new design mindset for continuous value creation in the Metaverse, a whole ecosystem of realities complimenting one another to consider, not just a channel in a mix.   The Metaverse will be much bigger than the Internet of today and will bring with it opportunities we cannot phantom yet. Do not dwarf it onto one channel! ',
    facebookText:
      'Join me to unpack how businesses should rethink their consumer strategies in the age of the Metaverse with #Omnireality',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'intermediate',
    speakers: ['b4693c6a-e519-4277-bfae-48d81ffa2a15'],
    talkType: 'introduction',
    title: 'Meet Consumers Across Realities ',
    track: 'Talk',
    twitterText:
      'Join me to unpack how businesses should rethink their consumer strategies in the age of the Metaverse with #Omnireality',
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: '',
    youtube: 'https://youtu.be/fMxB0TADiGA',
    talkGroup: '',
    order: 1,
    stream: ['Lightning Talk', 'User Interaction'],
    conferenceDay: 'day2',
    startTime: '10:40',
    endTime: '11:20',
    trackInDay: 1
  },
  {
    id: 'f090a654-dbd4-4905-b6d3-09e3162c0995',
    description:
      'If you’ve used a chatbot or a virtual assistant recently, you might have noticed how powerful they’ve now become. The latest generation of conversational AI engines can support a more “human” kind of interaction—building rapport, showing empathy, and developing a stronger relationship with users.  It means conversational AI is becoming an even more valuable tool in a broader range of business and customer-facing applications.  The talk will describe what Conversational AI is, why it works, how it can be responsibly used, and provide guidelines for effective implementation of these technologies.',
    facebookText: 'TBD',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['aafd62db-dd54-46ab-9040-4d105eb93762'],
    talkType: 'advanced',
    title: 'Voice and Conversational AI',
    track: 'Talk',
    twitterText: 'TBD',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/VCCZMMgjVhY',
    talkGroup: '',
    order: 1,
    stream: ['Data Science', 'Innovation and Sustainability', 'User Interaction'],
    conferenceDay: 'day2',
    startTime: '11:30',
    endTime: '12:10',
    trackInDay: 1
  },
  {
    id: 'b742749e-d88c-4925-8941-a8bf426c0145',
    description:
      "How Google's, more than two decades long, journey with open source created solutions that solve the biggest challenges of creating and operating true multi-cloud environments.",
    facebookText: 'provided later',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['edbc5832-77ed-4e58-93d8-2272208a74f5'],
    talkType: 'introduction',
    title: 'From Open Source to Multi-Cloud',
    track: 'Talk',
    twitterText: 'provided later',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: '',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '10:40',
    endTime: '11:20',
    trackInDay: 4
  },
  {
    id: 'ae39133f-9901-4f52-98c3-6ae97783ec42',
    description:
      'Intelligent Data Mesh at scale intertwines computation grid and distributed analytics across multiple data products and technologies for myriad of usages ranging from enterprise IT to IoT and Operational Technology (OT), and acts as a data system of systems.  Continuously evolving such data grids is costly to design and slow to deploy, due to lack of overarching transparency of interlaced data products and sources. There is a business need for faster creation of new distributed analytics and evolution of former ones, while adhering to changing requirements of data mesh systems, such as minimum energy and type of energy applied for sustainability regulations, technology footprint minimization, privacy restrictions, security enforcement, data lineage, data trust, and overall data quality. All while allowing organizations to simplify and automate the management of such governed intelligent data mesh.  The presented DataOps lifecycle methodology and Data Mesh Design Studio innovative technologies, provide a 360 degree value for KPI designers and domain subject matter experts (SMEs) that need to constantly optimize managed analytics over intelligent data mesh of interacting Data Products and distributed Data Nodes, as well as reuse domain specific ontologies and knowledge. Consequently, applying such technologies and methodology shortens analytics time-to-value; increases speed of delivery of new analytics value; increases data quality; and increases data utilization by increasing data reuse via ontological libraries. As a result, the approach simplifies the experience of data professionals throughout the analytics creation journey, including data scientists, data analysts, data engineers, and IT/OT experts via automated DataOps practice. During the talk, several data mesh pragmatic design models will be presented, such as the Europe Future Air Combat System (FCAS) demonstrating privacy and access requirements, Retail Analytics demonstrating edge computation, and Vehicles Fleet Management demonstrating real-time constrains.',
    facebookText:
      'How to untangle a Mess of a (data) Mesh? How can we ensure high quality federated analytics while minimizing carbon waste?  A Data specialist/domain owner/analytics leader - check out Prof. Hadar talk on designing Intelligent Data Mesh over sustainable edge-to-cloud continuum at #OpenSlava',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['9bf1e3fc-b9f0-48fe-a1f6-76c2a3d8260f'],
    talkType: 'advanced',
    title: 'Intelligent Data Mesh as the Future of Sustainable Distributed Data Platforms',
    track: 'Talk',
    twitterText:
      'Untangling a Mess of a Mesh? Check out Prof. Hadar talk on designing sustainable Intelligent Data Mesh at #OpenSlava!',
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: '',
    youtube: 'https://youtu.be/W6gYw4FgLhA',
    talkGroup: '',
    order: 1,
    stream: ['Data Science', 'Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '11:30',
    endTime: '12:10',
    trackInDay: 3
  },
  {
    id: '57698d52-a898-4248-8b08-6196ba36d57a',
    description:
      'Over the past couple of years, all tech giants started employing various kinds of technologies to support developers in their day-to-day coding activities and take coding to the next level.  Whether it is AI-assisted development or coding in the cloud, we want to explore what the future of software development might look like, by analyzing some of the most interesting technologies, discussing their strengths, possible use-cases, and trying some of them live on stage.',
    facebookText:
      "Join Martin Mayr & Georgia Moldovan, two technology architects at @Accenture to explore how next-generation developer tools could improve developers' day-to-day work. @OpenSlava",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'everyone',
    speakers: ['041a24c7-a827-4c5e-84f3-d4744ab68f40', '5c39a60f-46ee-46f4-bc82-4cfe11f4e3fa'],
    talkType: 'introduction',
    title:
      'How AI and Cloud will change the way we code - exploring the next generation of developer tools',
    track: 'Talk',
    twitterText:
      'Join @georgiamld  and @mayrmartin_ from @Accenture & explore how AI & Cloud based tools improve developers’ daily work.',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/I7rgtAjDQhg',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability', 'Live Coding Session'],
    conferenceDay: 'day2',
    startTime: '16:50',
    endTime: '17:30',
    trackInDay: 4
  },
  {
    id: 'ee6ac54d-6ee7-49ef-a0a6-8d8e162298e8',
    description:
      "With the advent of extremely rich Cloud Platforms, do we still need Technology Architects? Aren't all the difficult problems solved, and we “just“ need Full Stack Engineers to implement what the Business wants?",
    facebookText:
      "With the advent of extremely rich Cloud Platforms, do we still need Technology Architects? Aren't all the difficult problems solved, and we “just“ need Full Stack Engineers to implement what the Business wants?",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['630e8104-24e3-4de9-9b47-d40ca1ca1b5e'],
    talkType: 'introduction',
    title: 'Do we still need Technology Architects in 2023?',
    track: 'Talk',
    twitterText:
      'With the advent of extremely rich Cloud Platforms, do we still need Technology Architects?',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/r19iQLuLQ3k',
    talkGroup: '',
    order: 1,
    stream: ['Other'],
    conferenceDay: 'day2',
    startTime: '11:30',
    endTime: '12:10',
    trackInDay: 2
  },
  {
    id: 'def210ee-5089-4435-919f-7b688c4a0ae9',
    description:
      'Meet our Accenture Technology Innovation experts from Sophia Antipolis Labs and discover our vision of the Metaverse as well as some use cases to bring the Metaverse to life ',
    facebookText:
      'Meet Emmanuel Viale from Accenture Technology Innovation Europe to discover our vision of the Metaverse as well as some use cases to bring the Metaverse to life ',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['5a6d136e-c11b-4841-bbe9-eb7098d23189'],
    talkType: 'introduction',
    title: 'Metaverse Application Spectrum ',
    track: 'Talk',
    twitterText:
      'Emmanuel Viale from Accenture Technology Innovation will present Metaverse Application Spectrum at @OpenSlava',
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: '',
    youtube: 'https://youtu.be/On2xRQO9qxs',
    talkGroup: '',
    order: 1,
    stream: ['User Interaction'],
    conferenceDay: 'day2',
    startTime: '15:10',
    endTime: '15:50',
    trackInDay: 1
  },
  {
    id: 'd2ec41e1-9718-4db6-89bd-928d6a9ff7eb',
    description:
      'Modern Database Platforms need to give you seamless and fast availability of data anywhere at any time, online or offline. Any web portal and any mobile application needs to guarantee performance at any scale, which means not less than to deliver a perfect and differentiated, personalized user experience under all conditions, no matter if you need to serve 10, 1000 or millions of digital users. No matter where they are or if they’re online or offline. Couchbase Capella, available on AWS, Google Cloud and coming soon on Azure, gives your DevOps teams the power to build the base of globally distributed web services and mobile apps that can easily scale and keep up with increasing numbers of users and their need for speed.',
    facebookText: 'TBD',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['8003b162-77b2-423c-a815-1fee5997c8b7'],
    talkType: 'introduction',
    title:
      'Enhance User Experience with Always-on applications and Auto-synching data from cloud to edge',
    track: 'Talk',
    twitterText: 'TBD',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/j4Cq6zbb94A',
    talkGroup: '',
    order: 1,
    stream: ['Dev-Sec-Ops'],
    conferenceDay: 'day2',
    startTime: '10:40',
    endTime: '11:20',
    trackInDay: 3
  },
  {
    id: '2e80a664-3082-4ee6-8bc4-ffcc91ec0383',
    description:
      'Real life presentation how successful phishing attacks works. Brainstorming session fight between security team and criminals. Game where two teams fight for user credentials (participants of workshop will be assigned into the groups) Fishers - try to steal user credentials and access from user. Rats - corporate rats try fight against fishers to protect dummy users. Common user - have 1M$ on account and ability to click everywhere. ',
    facebookText: 'Fishing game - fight for 1M EUR',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'intermediate',
    speakers: ['62d62112-a4ce-4ceb-ad23-24beee12bae8'],
    talkType: 'advanced',
    title: 'Fishing game - fight for 1M EUR',
    track: 'Hands-on Lab/workshop',
    twitterText: 'Fishing game - fight for 1M EUR - @OpenSlava',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'B klub',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '15:30',
    endTime: '18:30',
    trackInDay: 1
  },
  {
    id: 'dacc2b0c-95f1-45dd-819e-51091f07b68b',
    description:
      'How much CO2 is produced to develop and run software? How to calculate it? And which programming language uses the least energy? Join this talk and be amazed!',
    facebookText:
      'How much CO2 is produced to develop and run software? Is JavaScript better than Python? Join this talk to find out!',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'intermediate',
    speakers: ['158dec14-4a45-4580-91b1-cf7852168b61', '26730903-ab37-4967-b89b-f60c35be453e'],
    talkType: 'introduction',
    title: 'How green is my software?',
    track: 'Talk',
    twitterText:
      'How much CO2 is produced to develop and run software? Is JavaScript better than Python? Join this talk to find out!',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/vVZ0ZPyugIs',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '16:50',
    endTime: '17:30',
    trackInDay: 0
  },
  {
    id: '773480f2-8509-4953-970e-bf23e444f240',
    description:
      'Remix is a modern framework for creating web applications with server side rendering based on React. Its focus is on performance, simplicity and maximum use of web standards. Our workshop will teach you how to transform a React application into a Remix app to best use the features provided by the framework and also see the benefits from server side rendering for the application performance. ',
    facebookText: 'Learn to create modern web applications with based on React together with Remix',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: ['2936b9c2-a163-41ca-98c9-669fba8c03b7', 'ceb23dec-010c-4409-9239-1ed1646e41e9'],
    talkType: 'introduction',
    title: 'Building web applications with Remix',
    track: 'Hands-on Lab/workshop',
    twitterText: 'Learn to create modern web applications with based on React together with Remix',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'E 701',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '08:30',
    endTime: '11:30',
    trackInDay: 1
  },
  {
    id: 'cf6a1ddb-bf5b-46ec-a2b5-c08a7803491e',
    description:
      "How to attribute revenue to marketing activities in a world where the old attribution methods don't work anymore? Market Mix Modelling is gaining traction as the new way to attribute revenue for your marketing investments as a reaction to the expected deprecation of the 3rd party cookie. I will talk about how we took the idea from a concept, through a PoC phase into a full-blown product. The focus will be on lessons learned from running the model, both from the technical, Data Science, and Product perspectives, and what it means to actually sell Machine Learning as a Product.",
    facebookText:
      "How to attribute revenue to marketing activities in a world where the old attribution methods don't work anymore? I will talk about how we took the idea from a concept, through a PoC phase into a full-blown product.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'intermediate',
    speakers: ['ab677149-6c97-491d-aed7-d0202114c9d9'],
    talkType: 'advanced',
    title: 'Market Mix Modelling in the 21st Century',
    track: 'Talk',
    twitterText:
      "How to attribute revenue to marketing in a world where the old attribution methods don't work?",
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: '',
    talkGroup: '',
    order: 1,
    stream: ['Data Science', 'Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '16:50',
    endTime: '17:30',
    trackInDay: 3
  },
  {
    id: '6f81f6b6-c3e4-48e4-a65a-4593797f5e54',
    description:
      'Large enterprises like Siemens are organized in self-responsible organizations that have many product development teams, facing common challenges like web and mobile technology and architecture style selection. With local product ownership, technology stacks and architectures are re-evaluated many times in different teams, and often result in different decisions. Sometime because of individual preferences and often without awareness of other team activities. Exchanging software components and developers across different products is hard. Risks for technology silos and closed product communities arise. Defining enterprise technology stacks is e.g. not feasible as they do not help local product development teams directly. Development teams need intrinsic motivation to spend time and effort in a global enterprise collaboration. SiMPL is the Siemens Mobile and Web Platform. SiMPL aims to support all Siemens organizations in development by reuse instead of re-implementation and foster a better Siemens-wide knowledge exchange, by promoting the same technology stack. The platform is based on Angular/Bootstrap for progressive web applications and Angular/Ionic for mobile applications. SiMPL is the glue between OSS components and development practices and Siemens industrial development by addressing the following goals: 1.Select and reuse OSS. 2.Make OSS technology stack and tools applicable in Siemens. 3.Add Siemens common components. 4.Provide best practices and tools for building web and mobile applications. 5.Small and modular packages to enable opt-in according product needs. 6.Support and implement different UX design systems with runtime theming. More than 200 internal and external applications have been developed with SiMPL. This talk introduces SiMPL and discusses the key frontend architecture and technology decisions around Angular and Ionic. It demonstrates key ingredients that led to high adoption rate and global enterprise collaboration. In addition, we report enterprise challenges like dependency management and OSS clearing and show case the platform with live coding samples.',
    facebookText:
      "Don't miss a chance and meet Timo Wolf, Global Key Expert in User Experience and Software Architecture. In his presentation he will introduce SiMPL (Siemens Mobile and Web Platform) and will show the audience live coding samples.",
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: ['e495e093-cdf5-4f28-a5a3-f2d18e7d9e5a'],
    talkType: 'advanced',
    title: 'SiMPL: aligning frontend technologies and OSS development practices at Siemens',
    track: 'Talk',
    twitterText:
      "Don't miss a chance and meet Timo Wolf, Global Key Expert in User Experience and Software Architecture @Openslava",
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/nUpQEsaD9PE',
    talkGroup: '',
    order: 1,
    stream: ['Live Coding Session', 'User Interaction'],
    conferenceDay: 'day2',
    startTime: '13:10',
    endTime: '13:50',
    trackInDay: 2
  },
  {
    id: '2b64bc95-4e61-44bd-b4d9-55e6b10f68e1',
    description:
      'Have you always wanted to dive into the quantum world? Do you want to know how to implement quantum algorithms? We show you how to hack quantum computing. We introduce you to the very basics of quantum technology. Then, we apply these to implement a quantum search algorithm and conduct a quantum credit risk analysis of financial assets. We are excited to share our passion with you.',
    facebookText:
      'Have you always wanted to dive into the quantum world? Take part in our workshop. Starting from the very basics of quantum computing you will end with implementing quantum search algorithms and quantum risk analysis.',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'beginner',
    speakers: ['219edef2-93ee-436f-a1a0-79e53b5eece1', '3021d7a2-6a2e-4788-aec5-64c8dd19e330'],
    talkType: 'introduction',
    title: 'Hacking the Quantum World - From Quantum Search to Quantum Risk Analysis',
    track: 'Hands-on Lab/workshop',
    twitterText:
      'You want to hack the quantum world? In this workshop you start from the basics and end with quantum risk analysis.',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'E 702',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '08:30',
    endTime: '11:30',
    trackInDay: 3
  },
  {
    id: 'de3b866e-8c7c-4489-a1df-9024bc399f14',
    description:
      'Increased EU-regulations lead to mindset change in regard to cloud usage in various industries across Europe. To increase cloud sovereignty from Non-EU based cloud service providers (CSP) like AWS, Azure or Google, companies can either develop a Cloud Sovereignty Layer on top of the Non-EU CSP service providers or use EU-based CSPs for specific workloads. In this session, we will discuss how Red Hat technologies can be leveraged to drive cloud sovereignty and illustrate this with a real-life example in the ACIC Zurich performing the live migration of a cloud native application from GCP to an on-premises datacenter using Red Hat technologies. ',
    facebookText:
      'Join us for an exciting talk about how to automatically migrate cloud native applications leveraging key Red Hat technologies to enable Cloud Sovereignty! ',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['48ac7fdc-96b4-474d-8dce-0d9813b22444', 'a94a2ace-93c7-4f40-a612-7a9720157889'],
    talkType: 'advanced',
    title: 'Migrating cloud native applications to support Cloud Sovereignty',
    track: 'Talk',
    twitterText:
      'Join our exciting session to discover how to migrate apps for Cloud Sovereignty with Accenture Cloud Innovation Center !',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/hN43bvwdexM',
    talkGroup: '',
    order: 1,
    stream: ['Other'],
    conferenceDay: 'day2',
    startTime: '11:30',
    endTime: '12:10',
    trackInDay: 4
  },
  {
    id: '1b066f53-2662-4d98-b075-338c9edc9eac',
    description:
      "The story of holistically thinking “cloud-native“ and finding a thoughtful middle-ground in technology selections and architecture between the extremes that just “dive-in“ without much reflection and others that really overthink it and due to lock-in fears, perceived special needs, etc... land at a technically highly sophisticated but business-wise awful place. But probably we're in the 80% (= not Google / Facebook / ...) so the cloud should really move us forward holistically so really compute, data, integration as well as ops & dev.",
    facebookText:
      "Let's talk about Cloud-Architecture in custom-dev for the 80% of us (= not GAFA or similar). We'll be covering compute, data, integration, ops & dev and especially: lock-in!",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'intermediate',
    speakers: ['80e579f4-f987-4841-95bc-0b8dd5dbb372'],
    talkType: 'advanced',
    title: 'Cloud-Architecture for the 80%',
    track: 'Talk',
    twitterText:
      "Let's talk about Cloud-Architecture in custom-dev for the 80% of us (= not GAFA or similar) @OpenSlava @DominiksTweets",
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/nCpDBtkX75A',
    talkGroup: '',
    order: 1,
    stream: ['Application Logic', 'Innovation and Sustainability', 'Other'],
    conferenceDay: 'day2',
    startTime: '10:40',
    endTime: '11:20',
    trackInDay: 2
  },
  {
    id: 'c8ca230d-3164-436a-abb7-ccfeb8284fc7',
    description:
      'Robotic vision finally becoming human-like.    Previously, robotic 3D vision could be either compared to a high-quality photograph or a very low-quality video. Now, thanks to the patented 3D cameras from Photoneo, robots can finally see the world in high-quality color 3D video - just like us.  Why do robots need 3D vision to manipulate objects around them? What does a perfect 3D vision of the future look like and why is it important?   Come and learn about industrial applications powered by patented 3D cameras from Photoneo. These sensors provide a continuous stream of color 3D data at a quality not matched by any other technology on the market. This opens new doors for future applications in many fields, such as manufacturing, industry, food processing, agriculture, medical industry, or metaverse.  Exploit the Photoneo 3D cameras in a practical workshop on your own computer, create a 3D model of yourself in a matter of seconds, and see the way the robots do. ',
    facebookText:
      'Previously, robotic 3D vision could be either compared to a high-quality photograph or a very low-quality video. Now, thanks to the patented 3D cameras from Photoneo, robots can finally see the world in high-quality color 3D video - just like us. Come and visit Photoneo at OpenSlava 22!',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: ['dedd4b05-258f-46bd-bba1-bf4d93586b67'],
    talkType: 'advanced',
    title: 'High quality real-time colorful 3D vision for robotics and metaverse',
    track: 'Hands-on Lab/workshop',
    twitterText:
      '@Photoneo and Marcel Svec will be presenting MotionCam-3D at @OpenSlava. Come and see the world in 3D!',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'BC 35',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '15:30',
    endTime: '18:30',
    trackInDay: 3
  },
  {
    id: '031f8a36-d906-4981-a03c-3c5e7f6b71ed',
    description:
      "During this session, google experts will guide participants though a real live e-commerce use case. We'll get our hands on the Google Cloud Platform and play with data models, data pipelines, ML models and serving endpoints. We'll build an end-to-end pipeline, from data ingestion to feature engineering, to model training and serving. Participants will need a basic understanding of cloud and distributed workloads, python, SQL, and sklearn. We'll use services like Cloud Shell, IAM, PubSub, BigQuery (ingestion service, queries and ML), Vertex AI (notebooks, Pipelines, and Endpoints).",
    facebookText: '-',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: ['13336ac0-34c9-4e9f-83b2-007481824a66'],
    talkType: 'advanced',
    title: 'Building end-to-end pipelines for model serving with Google Cloud',
    track: 'Hands-on Lab/workshop',
    twitterText: '-',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'E 701',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '15:30',
    endTime: '18:30',
    trackInDay: 0
  },
  {
    id: '98e10dc1-3c4b-4fc8-a276-1b2a4bbf342b',
    description:
      'The retail industry is currently undergoing one of its biggest transformations to date. Record-levels of attrition and the resulting worker shortage, ever-changing customer expectations and disruptions in the global supply chain – both exacerbated by the covid-19 pandemic -  turn the current retail landscape into treacherous territory for all its players.  Accenture has identified a key puzzle piece within a technological solution for these challenges: The implementation of robotics in retail. We enable this with our end-to-end retailer transformation blueprint, which reaches from inventory management all the way to store operations.    For this technological transformation to be successful, we work together with our clients to get three essential factors right every time:   ·       A clear strategy addressing the challenges of robotisation and its direct and indirect benefits    ·       The integration of the latest robotics simulation solutions to predict strong robotics KPIs  ·       A strong relationship with robotics networks to identify and build scalable robotics activation ',
    facebookText:
      'Join @christiansouche to listen about retail robotics: when robots will revolutionise shopping future',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['4f0a3cb8-b252-4114-bb2d-43e57fc7b5f2'],
    talkType: 'introduction',
    title: 'Retail Robotics when robots will revolutionize shopping future',
    track: 'Talk',
    twitterText:
      'Join @christiansouche to listen about retail robotics: when robots will revolutionise shopping future',
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: '',
    youtube: 'https://youtu.be/UMD1VJAY7nQ',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '13:10',
    endTime: '13:50',
    trackInDay: 4
  },
  {
    id: '7ba7e3b0-676c-4e9d-942b-40927af7d1b1',
    description:
      "Nowadays it's becoming a standard that developers not just build but also run their software. Managing deployments on Kubernetes it's not necessarily a simple task. In this talk we will take a look at how Kubernetes Operators can help with that and how to write one.  What are Kubernetes Operators? What are the involved design patterns? Why implement Kubernetes Operators in Java?  First we will answer these questions. In the second part, we will live code a simple Kubernetes Operator using Java Operator SDK, that makes it very clear how to start, how a standard Operator should look like in practice and how to implement the related design patterns.",
    facebookText: 'Learn how to run you application with Kubernetes Operators implemented in Java',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: ['67d7e9a4-e5be-4c97-9e0a-a81ca653ff87'],
    talkType: 'advanced',
    title: 'Implementing Kubernetes Operators in Java ',
    track: 'Talk',
    twitterText: 'Learn how to run you application with Kubernetes Operators implemented in Java',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/CvftaV-xrB4',
    talkGroup: '',
    order: 1,
    stream: ['Live Coding Session', 'Other'],
    conferenceDay: 'day2',
    startTime: '14:00',
    endTime: '14:40',
    trackInDay: 2
  },
  {
    id: 'c4df7896-9f2f-463f-80c1-fb0787576026',
    description: 'Lessons learned from the delivery of the world`s first corporate Metaverse ',
    facebookText:
      'Lessons learned from the delivery of the world`s first corporate Metaverse (e.on - sustainability)',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['3a74e42f-446f-45c5-9b49-67de9086a584', 'e199773c-8c33-4464-8aa9-ee329b485b7a'],
    talkType: 'advanced',
    title: 'Creating the Metaverse - Inventing virtual businesses',
    track: 'Talk',
    twitterText:
      'Lessons learned from the delivery of the world`s first corporate Metaverse (e.on - sustainability)',
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: '',
    youtube: 'https://youtu.be/dqNcfz-46sE',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability', 'User Interaction'],
    conferenceDay: 'day2',
    startTime: '13:10',
    endTime: '13:50',
    trackInDay: 1
  },
  {
    id: 'e10b1f11-0b63-4e3e-baa5-15aed008ce04',
    description:
      'It was in 2014 when I was first time standing here in Bratislava at this conference talking about “Digital Physical Blur & Wearable Technologies“ and we started incubating what now has become our Metaverse Continuum Business Group and a 1+bn business. You can still find the video of the talk on youtube Digital Physical Blur & Wearable Technologies (Matthias Ziegler): https://www.youtube.com/watch?v=bQfnLIoJ96Y. With the start of the FY23 on Sept 1 we have graduated this business, i.e. we have handed it over to the scaled part of the Accenture organization to further nurture and grow it. Now we are opening the next chapter for our Technology Incubation Groups and turn to the next wave of technologies to understand their value for our clients, incubate them and grow the next 1 bn business. Today I will share with you what those areas are and give some examples of our work and strategic directions. ',
    facebookText: 'TBD',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['db811648-8dd5-4b81-81bc-14a2ee5fea4b'],
    talkType: 'introduction',
    title: "What's next on the innovation horizon?",
    track: 'Talk',
    twitterText: 'TBD',
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: '',
    youtube: 'https://youtu.be/y0Iv6GupSc4',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '10:40',
    endTime: '11:20',
    trackInDay: 0
  },
  {
    id: '599ddc16-d03c-4ad0-9a39-b3ef3a83471d',
    description:
      "Come learn how to be happy with your web application UI and Back-end For Front-end (BFF) setup using the REGAL tech stack. We'll cover all 3 layers of UI, API, and Developer Operations (DevOps). The REGAL tech stack combines the programmatic parts of Functional Programming, the “focus on development and not OPs“  + cost savings of of Serverless, with the release early & often in trunk based Continuous Integration Continuous Delivery (CICD) workflows.  The individual parts of the REGAL tech stack consist of: - ReScript-lang for soundly typing your back-end for front-end API's w/the fastest compiler on the planet - Elm-lang for no errors ever in your front-end UI's using rich type modelling - GraphQL for powerful domain modelling and ensure your types match up between UI, BFF, and up stream/downstream API's your calling or if they call you - AWS Amplify and AppSync for serverless managed hosting & deployments of your UI and API - AWS Lambda for both API management as well as additional flexibility for more advanced application architectures  If you know React, Angular, or Vue, or variations of the MEAN and MERN stack and are looking for “what's next“ in UI and BFF framework tech stacks, REGAL is certainly one option. It uses the same UI and API development trends you do right now in the JavaScript ecosystem, yet rewards you with software that's more resilient where you can ensure the majority of your errors are either from the API's you're calling that you don't own, or race conditions. Using REGAL ensures all are errors are usually someone else' fault. Finally, we'll cover the changes coming to REGAL in the next couple of years.  ",
    facebookText:
      "Come learn how to get happiness w/your full stack UI & API setup using REGAL from Jesse Warden, specifically ReScript, Elm, GraphQL, AWS Amplify & AppSync, + Lambda. Know React/Angular/Vue/Express? Jesse will lay out the why & how in a way you'll grok immediately.  ",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'intermediate',
    speakers: ['858c16bf-5347-4bc5-a026-a5277d479dcb'],
    talkType: 'advanced',
    title: 'Fullstack Happiness Using the REGAL Stack ',
    track: 'Talk',
    twitterText:
      'Come learn how to get happiness w/your full stack UI & API setup using REGAL from Jesse Warden.',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/zoi0bsUCqnQ',
    talkGroup: '',
    order: 1,
    stream: ['Innovations', 'Interfaces', 'Live Coding Session'],
    conferenceDay: 'day2',
    startTime: '15:10',
    endTime: '15:50',
    trackInDay: 2
  },
  {
    id: '0ac7c123-ab98-42b9-b35a-dec11c507ca5',
    description:
      'Complex Systems are all around us, in particular when it comes to a better understanding of sustainability. But if we are to understand these systems we need to use technology and the application of data in completely different ways. Join Avanade as we explore the art of the possible with a new approach building on Digital Twin technology, Digital Cognition.',
    facebookText:
      "What really is 'the Metaverse' and where does the value lie? In this talk, we explore a new concept called 'Digital Cognition' and share how data is the foundation of value in the Metaverse.",
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'intermediate',
    speakers: ['69b25f0a-9b4f-4987-bc05-9facc8080810', 'adf9da9e-5f55-4ce9-a69d-2daabe1c3e4d'],
    talkType: 'introduction',
    title: 'Complex Systems; Moving from Digital Twin to Digital Cognition',
    track: 'Talk',
    twitterText:
      "What really is 'the Metaverse' and where does the value lie? Exploring a new concept, 'Digital Cognition'.",
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: '',
    youtube: 'https://youtu.be/Mxoq7MIM1gU',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability', 'Lightning Talk'],
    conferenceDay: 'day2',
    startTime: '16:00',
    endTime: '16:40',
    trackInDay: 1
  },
  {
    id: '5c6f6baf-e274-4292-ac85-0576df708bc5',
    description:
      'Google data centers are twice as energy efficient as a typical enterprise data center. Google has neutralized all legacy emissions since 1998 and matched 100% of electricity use with renewable energy since 2017. This includes the electricity that powers your workloads in Google Cloud. In my session, I will explain why Google Cloud is the cleanest cloud not only from sustainability point of view, but also the cleanest cloud for developers.',
    facebookText: 'TBD',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['edbc5832-77ed-4e58-93d8-2272208a74f5'],
    talkType: 'introduction',
    title: 'The Cleanest Cloud',
    track: 'Talk',
    twitterText: 'TBD',
    type: 'talk',
    technicalOrBusiness: 'business',
    time: '',
    room: '',
    youtube: '',
    talkGroup: '',
    order: 1,
    stream: ['Other'],
    startTime: '09:40',
    endTime: '10:10'
  },
  {
    id: '7cf654ff-0f3c-4c3c-839d-c9320901924a',
    description:
      'Let’s talk about Semantic Layer as knowledge graph that helps end users access data autonomously using common business terms. Find the power of storing data as network of real-world entities—i.e. objects, events, situations, or concepts—and illustrates the relationship between them. Explore capability of Graph database in the backend.',
    facebookText:
      'Knowledge Graph in data world with graph database behind a back - find out more at OpenSlava with Karol Lacuska',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'everyone',
    speakers: ['087335a0-7179-4baa-a49f-f51af3cc4c02'],
    talkType: 'introduction',
    title: 'Semantic Knowledge Graph as data modelling way',
    track: 'Talk',
    twitterText:
      'Knowledge Graph in data world with graph database behind a back - find out more @OpenSlava with Karol Lacuska',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://youtu.be/gTfGV5bkp24',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability', 'Other'],
    conferenceDay: 'day2',
    startTime: '15:10',
    endTime: '15:50',
    trackInDay: 3
  },
  {
    id: '1aca1163-b66e-45a4-ae5d-c61403427c46',
    description:
      'In this training, software engineers will learn and practice TDD to ship a React app. We will explore how this Extreme Programming (XP) technique encourages simple software design that will stand the test of time and inspires confidence in shipping software that works.  We will work through exercises specifically crafted to help engineers experiment with Test-Driven Development. Exercises will be done in pairs or triples via pair or ensemble programming. Participants will be coding right from the beginning, with short presentations made by the author in-between exercises.',
    facebookText:
      'Eager to dive deep into Test-Driven Development to ship a React app? Join Nik & Pavel of Erste Digital @OpenSlava to explore how this Extreme Programming (XP) technique encourages simple software design that will stand the test of time and inspires confidence in shipping software that works.',
    isClosed: false,
    isConfirmed: true,
    livecoding: true,
    proficiency: 'intermediate',
    speakers: ['dc770d8c-b286-4307-8f1a-e566bd6fb378', 'de2bce3a-c36b-4abb-9159-566a9132278c'],
    talkType: 'expert',
    title: 'Craft a React app like a PRO using Test-Driven Development',
    track: 'Hands-on Lab/workshop',
    twitterText:
      'Join Nik & Pavel of Erste Digital to take a deep dive into Test-Driven Development to ship a React app @OpenSlava. ',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: 'E 701',
    youtube: '',
    talkGroup: '',
    order: 1,
    conferenceDay: 'day1',
    startTime: '12:00',
    endTime: '15:00',
    trackInDay: 1
  },
  {
    id: 'ff889dd3-70ec-4564-879a-ef1ee7cc41e3',
    description:
      'Large corporations are a big part of the problem that we as a society are facing nowadays. But they can also be a key part of the solution. The climate crisis is pushing us towards sustainable development and more and more companies are starting to realize that this is not only a challenge, but an opportunity. Together with our panelists we will look at how technology and sustainability are interconnected and what are the main challenges that we need to address and overcome. ',
    facebookText:
      'Large corporations are a big part of the problem that we as a society are facing nowadays. But they can also be a key part of the solution. The climate crisis is pushing us towards sustainable development and more and more companies are starting to realize that this is not only a challenge, but an opportunity. Together with our panelists we will look at how technology and sustainability are interconnected and what are the main challenges that we need to address and overcome. ',
    isClosed: false,
    isConfirmed: true,
    livecoding: false,
    proficiency: 'beginner',
    speakers: [
      '158dec14-4a45-4580-91b1-cf7852168b61',
      '831076b5-3c4d-4dca-8683-bc3181b7572c',
      'aafd62db-dd54-46ab-9040-4d105eb93762',
      'ac8ffdef-fcab-41cd-b48a-50d66bf71acc'
    ],
    talkType: 'introduction',
    title: 'Technology and Sustainability Discussion',
    track: 'Talk',
    twitterText:
      'Large corporations are a big part of the problem that we as a society are facing nowadays. But they can also be a key part of the solution. The climate crisis is pushing us towards sustainable development and more and more companies are starting to realize that this is not only a challenge, but an opportunity. Together with our panelists we will look at how technology and sustainability are interconnected and what are the main challenges that we need to address and overcome. ',
    type: 'talk',
    technicalOrBusiness: 'technical',
    time: '',
    room: '',
    youtube: 'https://www.youtube.com/watch?v=m8DZBf0FgJI',
    talkGroup: '',
    order: 1,
    stream: ['Innovation and Sustainability'],
    conferenceDay: 'day2',
    startTime: '13:10',
    endTime: '14:30',
    trackInDay: 5
  }
];

export default talks;
